import { backendApi } from "../dynamicBAseQuery";

export const ChangePasswordApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        changePasswordByToken: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `changePasswordByToken`,
                body: { ...args }
            })
        }),

    })
})
export const {
    useChangePasswordByTokenMutation,
}= ChangePasswordApi